module.exports = __webpack_public_path__ + "static/media/editar_white.e0c02454.svg";